import React, { useContext, useEffect } from "react";
import Internship_Banner from "../../common_components/internship_Banner/Internship_Banner";
import Luxury_Hospitality from "./luxury_Hospitality/Luxury_Hospitality";
import Internship_about from "./internship_about/Internship_about";
import Departments_available from "./departments_available/Departments_available";
import What_makes from "./what_makes/What_makes";
import Why_Ambassadeur from "./why_Ambassadeur/Why_Ambassadeur";
import Internship_is_Ideal from "../../common_components/internship_is_Ideal/Internship_is_Ideal";
import Get_started from "../../home/get_started/Get_started";

import { useParams } from "react-router-dom";
import { GetAllDataOfInternship } from "../../features/internship/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../utils/context";

function France() {
  const dispatch = useDispatch();

  const { id } = useParams();

  const { language, setLanguage } = useContext(Context);

  console.log(id, "id");

  const allData = useSelector(
    (state) => state?.internship?.GetAllInternship?.all_data_of_internship,
  );

  console.log(allData, "allData");

  useEffect(() => {
    dispatch(GetAllDataOfInternship({ id, language }));
  }, [dispatch, id, language]);

  return (
    <>
      <Internship_Banner
        heading_Text={
          allData?.InternshipBanner?.InternshipBanner_Lang?.name ||
          "We nurture talent across the globe"
        }
        text_normal_1={
          allData?.InternshipBanner?.InternshipBanner_Lang?.mid ||
          "Our international internship network gives students access To real Hospitality Experience, Cultural Immersion, and Opportunities that shape their Professional Future."
        }
        // textbold_1="Hospitality Experience,"
        // text_normal_2=" Cultural Immersion, and Opportunities that shape their Professional Future."
        // text_normal_3=" Each destination is carefully selected for its"
        textbold_2={
          allData?.InternshipBanner?.InternshipBanner_Lang?.last ||
          "Each destination is carefully selected for its Quality of Training, Safety, & Career Potential."
        }
      />
      <Luxury_Hospitality data={allData?.WebLuxuryHospialities} />
      <Why_Ambassadeur data={allData?.WebWhatYouGets} />
      <Internship_about data={allData} />

      <div className="notepp">
        <p>
          {allData?.WebPurpleStrip?.WebPurpleStrip_Lang?.name ||
            "Placement, department, and post-internship opportunities depend on profile, performance, and host availability."}
        </p>
      </div>
      <What_makes data={allData} />

      <Internship_is_Ideal
        // normal_text="France is Ideal for Students "
        bold_text={
          allData?.WebBelowWhatMakeunique?.WebBelowWhatMakeUnique_Lang?.name ||
          `${allData?.name} is Ideal for Students Seeking Discipline, Precision, and Luxury hospitality experience`
        }
      />
      <Departments_available data={allData?.WebDepartmentAvailables} />

      {/* <Internship_is_Ideal
        normal_text="We create pathways where students don’t just complete an internship, they grow into
globally confident professionals."
        // bold_text=" They evolve into Globally Confident Professionals"
      /> */}


      <Internship_is_Ideal
        normal_text={language == 1 ? "We create pathways where students don’t just complete an internship, they grow into globally confident professionals." : "Nous créons des parcours où les étudiants ne se contentent pas d'effectuer un stage, mais s'épanouissent pour devenir des professionnels confiants à l'échelle mondiale."}
        // bold_text=" They evolve into Globally Confident Professionals"
      />
      <Get_started />
    </>
  );
}

export default France;
